"use client";

import { Trans, useLingui } from "@lingui/react/macro";
import { AuthCardLayout } from "~/components/auth/AuthCardLayout";
import { VerifyEmailFormContent, type VerifyEmailFormContentProps } from "./VerifyEmailFormContent";

export const VerifyEmailForm = ({ email, ...contentProps }: VerifyEmailFormContentProps & { email: string }) => {
	const { t } = useLingui();
	return (
		<AuthCardLayout
			title={t`Verify your email`}
			description={
				<Trans>
					Enter the verification code sent to <b>{email}</b>. It may take a few minutes for the email to
					arrive.
				</Trans>
			}
		>
			<VerifyEmailFormContent {...contentProps} />
		</AuthCardLayout>
	);
};
